export default function formatTime(dateISOString) {
  const options = {
    hour: '2-digit',
    minute: '2-digit',
  };
  const locale = 'ru-RU';
  const date = new Date(dateISOString);
  return date.toLocaleTimeString(locale, options);
}